"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.index-of.js");

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('ul', {
    staticClass: "el-pager",
    attrs: {},
    on: {
      "click": _vm.onPagerClick
    }
  }, [_vm.pageCount > 0 ? _c('li', {
    staticClass: "number",
    "class": {
      active: _vm.currentPage === 1,
      disabled: _vm.disabled
    },
    attrs: {}
  }, [_vm._v("1")]) : _vm._e(), _vm._v(" "), _vm.showPrevMore ? _c('li', {
    staticClass: "el-icon more btn-quickprev",
    "class": [_vm.quickprevIconClass, {
      disabled: _vm.disabled
    }],
    attrs: {},
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.onMouseenter('left');
      },
      "mouseleave": function mouseleave($event) {
        _vm.quickprevIconClass = 'el-icon-more';
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.pagers, function (pager) {
    return _c('li', {
      key: pager,
      staticClass: "number",
      "class": {
        active: _vm.currentPage === pager,
        disabled: _vm.disabled
      },
      attrs: {}
    }, [_vm._v("\n    " + _vm._s(pager) + "\n  ")]);
  }), _vm._v(" "), _vm.showNextMore ? _c('li', {
    staticClass: "el-icon more btn-quicknext",
    "class": [_vm.quicknextIconClass, {
      disabled: _vm.disabled
    }],
    attrs: {},
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.onMouseenter('right');
      },
      "mouseleave": function mouseleave($event) {
        _vm.quicknextIconClass = 'el-icon-more';
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.pageCount > 1 ? _c('li', {
    staticClass: "number",
    "class": {
      active: _vm.currentPage === _vm.pageCount,
      disabled: _vm.disabled
    },
    attrs: {}
  }, [_vm._v("\n    " + _vm._s(_vm.pageCount) + "\n  ")]) : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElPager',
  props: {
    currentPage: Number,
    pageCount: Number,
    pagerCount: Number,
    disabled: Boolean
  },
  watch: {
    showPrevMore: function showPrevMore(val) {
      if (!val) this.quickprevIconClass = 'el-icon-more';
    },
    showNextMore: function showNextMore(val) {
      if (!val) this.quicknextIconClass = 'el-icon-more';
    }
  },
  methods: {
    onPagerClick: function onPagerClick(event) {
      var target = event.target;

      if (target.tagName === 'UL' || this.disabled) {
        return;
      }

      var newPage = Number(event.target.textContent);
      var pageCount = this.pageCount;
      var currentPage = this.currentPage;
      var pagerCountOffset = this.pagerCount - 2;

      if (target.className.indexOf('more') !== -1) {
        if (target.className.indexOf('quickprev') !== -1) {
          newPage = currentPage - pagerCountOffset;
        } else if (target.className.indexOf('quicknext') !== -1) {
          newPage = currentPage + pagerCountOffset;
        }
      }
      /* istanbul ignore if */


      if (!isNaN(newPage)) {
        if (newPage < 1) {
          newPage = 1;
        }

        if (newPage > pageCount) {
          newPage = pageCount;
        }
      }

      if (newPage !== currentPage) {
        this.$emit('change', newPage);
      }
    },
    onMouseenter: function onMouseenter(direction) {
      if (this.disabled) return;

      if (direction === 'left') {
        this.quickprevIconClass = 'el-icon-d-arrow-left';
      } else {
        this.quicknextIconClass = 'el-icon-d-arrow-right';
      }
    }
  },
  computed: {
    pagers: function pagers() {
      var pagerCount = this.pagerCount;
      var halfPagerCount = (pagerCount - 1) / 2;
      var currentPage = Number(this.currentPage);
      var pageCount = Number(this.pageCount);
      var showPrevMore = false;
      var showNextMore = false;

      if (pageCount > pagerCount) {
        if (currentPage > pagerCount - halfPagerCount) {
          showPrevMore = true;
        }

        if (currentPage < pageCount - halfPagerCount) {
          showNextMore = true;
        }
      }

      var array = [];

      if (showPrevMore && !showNextMore) {
        var startPage = pageCount - (pagerCount - 2);

        for (var i = startPage; i < pageCount; i++) {
          array.push(i);
        }
      } else if (!showPrevMore && showNextMore) {
        for (var _i = 2; _i < pagerCount; _i++) {
          array.push(_i);
        }
      } else if (showPrevMore && showNextMore) {
        var offset = Math.floor(pagerCount / 2) - 1;

        for (var _i2 = currentPage - offset; _i2 <= currentPage + offset; _i2++) {
          array.push(_i2);
        }
      } else {
        for (var _i3 = 2; _i3 < pageCount; _i3++) {
          array.push(_i3);
        }
      }

      this.showPrevMore = showPrevMore;
      this.showNextMore = showNextMore;
      return array;
    }
  },
  data: function data() {
    return {
      current: null,
      showPrevMore: false,
      showNextMore: false,
      quicknextIconClass: 'el-icon-more',
      quickprevIconClass: 'el-icon-more'
    };
  }
};
exports["default"] = _default;